// The «ΦΠΑ 39Α» step is a conditional middle step. It appears only when ALL hold:
//   • the cart has eligible products (server-computed `available`),
//   • the customer chose τιμολόγιο (invoice) in step 1, and
//   • the invoice ΑΦΜ is CONFIRMED 39Α-eligible (AADE Su1 → 'validated') — either
//     from a previously-validated profile or validated live after entering the VAT.
// Pure so it can be unit-tested.
export function should39aStep(tax39a, docType, afmStatus) {
  return !!(tax39a && tax39a.available) && docType === 'invoice' && afmStatus === 'validated';
}

// Normalise a ΑΦΜ to the last 9 digits (mirrors FPA_39A_Meta::normalize_afm).
export function normalizeAfm(vat) {
  return String(vat || '').replace(/\D/g, '').slice(-9);
}
